module.exports = __webpack_public_path__ + "img/fruit.7fd8066d.jpg";